/* DOUBLIX — Preview IA
   Upload photo -> downscale côté client -> Worker -> fal.ai -> résultat.
   La clé API vit dans le Worker, jamais ici. */
(function () {
  'use strict';

  var MAX_UPLOAD_BYTES = 15 * 1024 * 1024;
  var MAX_EDGE = 1024;          // on redimensionne avant l'envoi : plus rapide, moins cher
  var JPEG_QUALITY = 0.82;
  var POLL_INTERVAL_MS = 1800;
  var POLL_TIMEOUT_MS = 120000; // nano-banana-2 (Gemini 3 Pro Image) peut être un peu plus lent
  var ACCEPTED = ['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif'];

  function t(el, key, fallback) {
    return el.getAttribute('data-i18n-' + key) || fallback;
  }

  /* Redimensionne + ré-encode en JPEG, renvoie une data URI. */
  function downscale(file) {
    return new Promise(function (resolve, reject) {
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        URL.revokeObjectURL(url);
        var w = img.naturalWidth;
        var h = img.naturalHeight;
        if (!w || !h) { reject(new Error('decode')); return; }

        var scale = Math.min(1, MAX_EDGE / Math.max(w, h));
        var cw = Math.round(w * scale);
        var ch = Math.round(h * scale);

        var canvas = document.createElement('canvas');
        canvas.width = cw;
        canvas.height = ch;
        var ctx = canvas.getContext('2d');
        ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(img, 0, 0, cw, ch);

        try {
          resolve(canvas.toDataURL('image/jpeg', JPEG_QUALITY));
        } catch (e) {
          reject(e);
        }
      };
      img.onerror = function () {
        URL.revokeObjectURL(url);
        reject(new Error('decode'));
      };
      img.src = url;
    });
  }

  function AiPreview(root) {
    this.root = root;
    this.endpoint = (root.getAttribute('data-endpoint') || '').replace(/\/$/, '');
    this.demo = root.getAttribute('data-demo') === 'true';
    this.demoImage = root.getAttribute('data-demo-image') || '';

    this.input = root.querySelector('[data-ai-input]');
    this.dropzone = root.querySelector('[data-ai-dropzone]');
    this.generateBtn = root.querySelector('[data-ai-generate]');
    this.resetBtn = root.querySelector('[data-ai-reset]');
    this.error = root.querySelector('[data-ai-error]');
    this.srStatus = root.querySelector('[data-ai-sr]');
    this.beforeImg = root.querySelector('[data-ai-before]');
    this.afterImg = root.querySelector('[data-ai-after]');
    this.progressLabel = root.querySelector('[data-ai-progress-label]');

    this.dataUri = null;
    this.timer = null;

    this.bind();
    this.setState('idle');
  }

  AiPreview.prototype.bind = function () {
    var self = this;

    if (this.input) {
      this.input.addEventListener('change', function (e) {
        if (e.target.files && e.target.files[0]) self.accept(e.target.files[0]);
      });
    }

    if (this.dropzone) {
      ['dragenter', 'dragover'].forEach(function (ev) {
        self.dropzone.addEventListener(ev, function (e) {
          e.preventDefault();
          self.dropzone.classList.add('is-dragging');
        });
      });
      ['dragleave', 'drop'].forEach(function (ev) {
        self.dropzone.addEventListener(ev, function (e) {
          e.preventDefault();
          self.dropzone.classList.remove('is-dragging');
        });
      });
      self.dropzone.addEventListener('drop', function (e) {
        var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
        if (f) self.accept(f);
      });
    }

    if (this.generateBtn) {
      this.generateBtn.addEventListener('click', function () { self.generate(); });
    }
    if (this.resetBtn) {
      this.resetBtn.addEventListener('click', function () { self.reset(); });
    }
  };

  AiPreview.prototype.setState = function (state) {
    this.root.setAttribute('data-state', state);
    if (this.generateBtn) {
      this.generateBtn.disabled = state === 'loading' || state === 'idle';
    }
  };

  AiPreview.prototype.say = function (msg) {
    if (this.srStatus) this.srStatus.textContent = msg;
  };

  AiPreview.prototype.showError = function (msg) {
    if (this.error) {
      this.error.textContent = msg;
      this.error.hidden = false;
    }
    this.say(msg);
  };

  AiPreview.prototype.clearError = function () {
    if (this.error) { this.error.hidden = true; this.error.textContent = ''; }
  };

  AiPreview.prototype.accept = function (file) {
    var self = this;
    this.clearError();

    if (file.size > MAX_UPLOAD_BYTES) {
      this.showError(t(this.root, 'size', 'Photo trop lourde (15 Mo max).'));
      return;
    }
    // Certains navigateurs renvoient un type vide pour les HEIC — on tolère et on laisse le decode trancher.
    if (file.type && ACCEPTED.indexOf(file.type) === -1) {
      this.showError(t(this.root, 'format', 'Format non supporté. Utilise JPG, PNG ou WEBP.'));
      return;
    }

    this.setState('processing');
    this.say(t(this.root, 'reading', 'Lecture de la photo…'));

    downscale(file)
      .then(function (uri) {
        self.dataUri = uri;
        if (self.beforeImg) self.beforeImg.src = uri;
        self.setState('ready');
        self.say(t(self.root, 'ready', 'Photo prête. Lance la preview.'));
      })
      .catch(function () {
        self.setState('idle');
        self.showError(t(self.root, 'decode', "Impossible de lire cette photo. Essaie un JPG ou un PNG."));
      });
  };

  AiPreview.prototype.selectedStyle = function () {
    var checked = this.root.querySelector('[data-ai-style]:checked');
    return checked ? checked.value : 'classic';
  };

  AiPreview.prototype.generate = function () {
    if (!this.dataUri) return;
    var self = this;
    this.clearError();
    this.setState('loading');
    this.say(t(this.root, 'generating', 'Génération en cours…'));
    this.tickProgress();

    if (this.demo) {
      // Mode démo : pas d'appel API, on montre le rendu d'exemple.
      setTimeout(function () {
        if (self.afterImg) self.afterImg.src = self.demoImage;
        self.finish(true);
      }, 2600);
      return;
    }

    if (!this.endpoint) {
      this.setState('ready');
      this.showError(t(this.root, 'noendpoint', 'Preview non configurée pour le moment.'));
      return;
    }

    fetch(this.endpoint + '/generate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ image: this.dataUri, style: this.selectedStyle() })
    })
      .then(function (r) {
        return r.json().then(function (d) { return { ok: r.ok, status: r.status, data: d }; });
      })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data && res.data.message ? res.data.message : 'upstream');
        if (!res.data.id) throw new Error('upstream');
        self.poll(res.data.id, Date.now());
      })
      .catch(function (err) {
        self.fail(err);
      });
  };

  AiPreview.prototype.poll = function (id, startedAt) {
    var self = this;

    if (Date.now() - startedAt > POLL_TIMEOUT_MS) {
      this.fail(new Error(t(this.root, 'timeout', 'La génération prend trop de temps. Réessaie.')));
      return;
    }

    fetch(this.endpoint + '/status?id=' + encodeURIComponent(id))
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d.status === 'COMPLETED') {
          return self.fetchResult(id);
        }
        self.timer = setTimeout(function () { self.poll(id, startedAt); }, POLL_INTERVAL_MS);
      })
      .catch(function (err) { self.fail(err); });
  };

  AiPreview.prototype.fetchResult = function (id) {
    var self = this;
    return fetch(this.endpoint + '/result?id=' + encodeURIComponent(id))
      .then(function (r) {
        return r.json().then(function (d) { return { ok: r.ok, data: d }; });
      })
      .then(function (res) {
        if (!res.ok || !res.data.image) throw new Error(res.data && res.data.message ? res.data.message : 'no_image');
        if (self.afterImg) self.afterImg.src = res.data.image;
        self.finish(false);
      });
  };

  AiPreview.prototype.tickProgress = function () {
    var self = this;
    var msgs = (this.root.getAttribute('data-i18n-steps') || '').split('|').filter(Boolean);
    if (!msgs.length || !this.progressLabel) return;
    var i = 0;
    this.progressLabel.textContent = msgs[0];
    this.progressTimer = setInterval(function () {
      if (self.root.getAttribute('data-state') !== 'loading') {
        clearInterval(self.progressTimer);
        return;
      }
      i = (i + 1) % msgs.length;
      self.progressLabel.textContent = msgs[i];
    }, 2800);
  };

  AiPreview.prototype.finish = function (isDemo) {
    clearInterval(this.progressTimer);
    this.setState('done');
    this.root.setAttribute('data-demo-result', String(!!isDemo));
    this.say(t(this.root, 'done', 'Ta preview est prête !'));
    var result = this.root.querySelector('[data-ai-result]');
    if (result && typeof result.scrollIntoView === 'function') {
      result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  };

  AiPreview.prototype.fail = function (err) {
    clearInterval(this.progressTimer);
    this.setState('ready');
    var msg = (err && err.message && err.message !== 'upstream')
      ? err.message
      : t(this.root, 'failed', "La génération a échoué. Réessaie dans un instant.");
    this.showError(msg);
  };

  AiPreview.prototype.reset = function () {
    clearTimeout(this.timer);
    clearInterval(this.progressTimer);
    this.dataUri = null;
    if (this.input) this.input.value = '';
    if (this.afterImg) this.afterImg.removeAttribute('src');
    if (this.beforeImg) this.beforeImg.removeAttribute('src');
    this.clearError();
    this.setState('idle');
  };

  function init() {
    document.querySelectorAll('[data-ai-preview]').forEach(function (el) {
      if (el.__aiInit) return;
      el.__aiInit = true;
      new AiPreview(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
